module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_parking.e20e67ed.png";